import * as React from 'react';
import BuyerResetPasswordForm from '../buyer_reset_password_form/BuyerResetPasswordForm';
import { Layout, Row, Col, BackTop, Card } from 'antd';
import { withRouter } from 'react-router';
import { parseQueryParams } from '../../utils/DataAccessUtils';

const { Content } = Layout;
const style = require('./BuyerResetPasswordPage.less');
const style2 = require('../../styles/blah.less');

class BuyerResetPasswordPage extends React.Component<any, any> {
	render() {
		const params = parseQueryParams(this.props.location.search);
		const token = params.resetToken;
		return (
			<Content className="resetPasswordPage" style={{ padding: '0 0.5em' }}>
				<BackTop />
				<Row align="middle" style={{ height: '100vh' }} justify="center" gutter={16}>
					<Card title="Choose a new password">
						<BuyerResetPasswordForm token={token} />
					</Card>
				</Row>
			</Content>
		);
	}
}

export default withRouter(BuyerResetPasswordPage);
